import { appConfig, userData } from '../config';

export interface PerformanceMonitorConfig {
  baseUrl: string;
  enabled: boolean;
  ua?: any;
  userlevel?: number;
  abd?: boolean;
  appVersion: string;
}

export function getPerformanceMonitorConfig(): PerformanceMonitorConfig {
  const servicesConfig = appConfig.core ? appConfig.core.services /* istanbul ignore next else */ : {};
  const monitoringConfig = (servicesConfig && servicesConfig.monitoring) /* istanbul ignore next else */ || {};

  return {
    baseUrl: /* istanbul ignore next else */ monitoringConfig.baseUrl || monitoringConfig.baseUrlDuration,
    enabled: !!monitoringConfig.enabled,
    ua: userData.ua,
    userlevel: userData.userlevel,
    abd: userData.abd,
    appVersion: appConfig.appVersion,
  };
}
